"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleType = void 0;
var RuleType;
(function (RuleType) {
    RuleType["ROLE_RULE"] = "ROLE_RULE";
    RuleType["USER_RULE"] = "USER_RULE";
    RuleType["AND_RULE"] = "AND_RULE";
    RuleType["OR_RULE"] = "OR_RULE";
    RuleType["NOT_RULE"] = "NOT_RULE";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
//# sourceMappingURL=notification-template-types.js.map